export const Routes = {
  ROOT: '/',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/password-reset/',
  ASSETS: {
    ROOT: '/assets',
    ADD: '/assets/create',
    EDIT: '/assets/:assetId',
    INVESTMENT: '/assets/:assetId/investment',
    NOTARY: '/assets/:assetId/notary',
    SERIAL_NUMBER: '/assets/:assetId/serial-number',
    FORUM: '/assets/:assetId/forum',
    INVESTORPAYOUT: '/assets/:assetId/investorpayout',
    YEARLYTAXREPORT: '/assets/:assetId/yearlytaxreport',
    PREORDER: '/assets/:assetId/preorder',
    RECORDS: '/assets/:assetId/records',
    APPROVAL: '/assets/:assetId/approval',
  },
  PAYMENT: {
    ROOT: '/payment',
    ACCOUNT: '/payment/account/:spvId',
    RENT: '/payment/rent/:spvId',
  },
  ISSUER: {
    ROOT: '/issuer',
    PROFILE: '/issuer/profile/:spvId',
    CREATE: '/issuer/create',
    TAX: '/issuer/tax/:spvId',
  },
  AFFILIATE: {
    ROOT: '/affiliate',
  },
  TRANSACTIONS: {
    ROOT: '/transactions',
    PENDING: '/transactions/pending',
    COMPLETED: '/transactions/completed',
  },
  PARTNER: {
    ROOT: '/partner',
  },
  REVENUE_POOLS: {
    ROOT: '/revenuePools',
    ADD: '/revenuePools/create',
    EDIT: '/revenuePools/:poolId',
  },
};
